module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-wrap"
  }, [(_vm.useLabel) ? _c('label', {
    staticClass: "label input__label",
    attrs: {
      "for": this.id
    }
  }, [_vm._v(_vm._s(this.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.setWrapperClass
  }, [(this.type !== 'textarea') ? _c('input', {
    class: _vm.setClass,
    attrs: {
      "id": this.id,
      "type": _vm.setType,
      "placeholder": _vm.placeholder,
      "data-type": _vm.setDataType,
      "disabled": this.disabled
    },
    domProps: {
      "value": _vm.setValue
    },
    on: {
      "change": _vm.saveValue
    }
  }) : _c('textarea', {
    class: _vm.setClass,
    attrs: {
      "id": this.id,
      "type": _vm.setType,
      "placeholder": _vm.placeholder,
      "data-type": _vm.setDataType,
      "disabled": this.disabled
    },
    domProps: {
      "value": _vm.setValue
    },
    on: {
      "change": _vm.saveValue
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-375dec91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextInput.vue
// module id = 316
// module chunks = 0